export const PlaybookAndStandardInternalMessages = {
  MAIN: {
    TITLE: 'Comparison Parameters',
    SUBTITLE: 'Add/Edit/Delete modify the given parameter',
  },
  CARD: {
    TITLE: 'Comparison Parameters',
    SUBTITLE: 'Select the parameters and Sub Parameters you want to compare.',
  },
  NO_DATA: {
    CONTENT: 'No parameters are available at the moment.',
  },
};

export const IMPACT_OPTIONS = ['Cost', 'Fiduciary', 'Compliance', 'Liability'];

export const PLAYBOOK_AND_STANDARD_INTERNAL_TABLE_COLUMNS = [
  {
    name: 'Plan Sponsor',
    width: '10%',
    key: 'plansponsor',
    isFlag: true,
  },
  { name: 'Provision Name', width: '20%', key: 'value' },
  {
    name: 'Assessment Description',
    width: '30%',
    key: 'assessment',
  },
  // { name: 'Impact', width: '15%', key: 'impact' },
  {
    name: 'Legal Doctorine',
    width: '15%',
    key: 'legal_doctorine',
  },
  {
    name: 'Legal Citation',
    width: '35%',
    key: 'legal_citation',
  },
  { name: 'Importance', width: '10%', key: 'importance' },
];
